
import { Action } from "../../types/Action";
import { SET_CLAN_BATTLES, TOGGLE_BATTLES_ERROR, TOGGLE_SELECTED_BATTLE, TOGGLE_CLAN_BATTLES_FETCH } from "../Actions/ActionClanBattles";

const initialState = {
  battlesList: [],
  isError: false,
  isFetching: true,
  errorMessage: '',
  selectedBattle: 0
};

export type IReducerBattles = (state: State, action: Action) => State;
export const ReducerBattles = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;

  }
};

export const clanBattles = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLAN_BATTLES:
      return {
        ...state,
        battlesList: action.battlesList
      };

    case TOGGLE_BATTLES_ERROR:
      return Object.assign({}, state, {
        isError: action.isError,
        errorMessage: action.errorMessage
      });

    case TOGGLE_SELECTED_BATTLE:
      return Object.assign({}, state, {
        selectedBattle: action.selectedBattle
      });
    case TOGGLE_CLAN_BATTLES_FETCH:
      {
        return Object.assign({}, state, {
          isFetching: action.isFetching
        });
      }
    default:
      return state;

  }
};